var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 235 235",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Untitled 14")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#F9EBAF",
    points: "233 116.497268 116.502732 233 0 116.497268 116.502732 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#6EAD92",
    points: "116 0 233 116.497268 116 233"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-52",
    fill: "#D9433C",
    points: "58.5 174.994529 0 116.663019 117 0 58.4945132 58.3369806 117 58.3369806 117 116.66849 58.4945132 175"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-53",
    fill: "#78403F",
    points: "117 117 117 58.5027433 174.994561 58.4972567 175 58.5027433 117 117"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#7A908C",
    points: "116 233 58 175 116 175"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#3C7D7B",
    points: "117 233 117 233 117 175 175 175"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-59",
    fill: "#7C3C3F",
    points: "58 58 116 0 116 57.9945601"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-60",
    fill: "#503A3E",
    points: "117 58 117 0 117.00544 0.00543936978 175 57.9945606"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Logo.98ebac76.svg";
export { ForwardRef as ReactComponent };